import { Dialog, DialogContent } from "@mui/material";
import CorrectionForm from "./CorrectionForm";
import InfoDescriptionForm from "./InfoDescriptionForm";
import QuantityForm from "../QuantityForm/QuantityForm";
import VariationsModal from "../scripts/VariationsModal";
import AppDialog from "../ui/AppDialog";
import AttributesListModal from "../scripts/AttributesListModal";

function ProductInfoModal({
  open,
  onClose,
  modalType,
  attributes,
  setAttributes,
  modalRef,
  setSelectedAttrIndex,
  selectedAttrIndex,
  setModalType,
  setQuantity,
  quantity,
}) {
  console.log(modalType);
  const renderContent = () => {
    switch (modalType) {
      case "quantity":
        return (
          <QuantityForm
            onClose={onClose}
            setQuantity={setQuantity}
            quantity={quantity}
          />
        );
      case "attribute_list":
        return (
          <AttributesListModal
            attributes={attributes}
            setAttributes={setAttributes}
            onClose={onClose}
            onEditVariations={(idx) => {
              setSelectedAttrIndex(idx);
              setModalType("attribute_variations");
            }}
          />
        );
      case "attribute_variations":
        return (
          <VariationsModal
            attributes={attributes}
            setAttributes={setAttributes}
            attrIndex={selectedAttrIndex}
            onClose={onClose}
          />
        );
      case "correction":
        return <CorrectionForm onClose={onClose} />;
      case "description":
        return <InfoDescriptionForm onClose={onClose} />;
      default:
        return null;
    }
  };

  return (
    <AppDialog open={open} onClose={onClose} ref={modalRef}>
      {renderContent()}
    </AppDialog>
  );
}

export default ProductInfoModal;
